<div class="menu">
  <a  routerLink="/"><img [src]="logoIndustriaPaisaia" width="150" height="60" alt=""/></a>
  <nav>
    <ul class="nav">
      <!-- <li class="nav-item" [routerLink]='home' [routerLinkActive]="['active']">Inicio</li> -->
      <li *ngFor="let page of pages" class="nav-item" [routerLink]=page.slug [routerLinkActive]="['active']" [id]="'nav-'+page.slug">{{page.title}}</li>
    </ul>
  </nav>
  <!-- search -->
  <div id="search" class="Search" style="display:none;">
    <input type="search" placeholder="Search for a title..." value=""/>
  </div>
  <div class="language" style="">
    <span><a [href]="getLink('eu')">EU</a></span> <span></span> <span><a [href]="getLink('es')">ES</a></span>
  </div>
</div>
